import { create, useStore } from 'zustand';

export type QuickRepartitionType = {
    selectedRcuIds: string[];
    boostPerMember: number;
    boostTotalAmount: number;
    allRcuIds: string[];
    maxConsumedBoosts: number;
    disabledRcuIds: string[];
    warningMessage?: string;
};

type QuickRepartitionStore = {
    quickRepartition: QuickRepartitionType;
    setQuickRepartition: (value: QuickRepartitionType) => void;
    setSelectedRcuIdentifiers: (value: string[]) => void;
    setBoostPerMember: (value: number) => void;
    setBoostTotalAmount: (value: number) => void;
    setAllRcuIdentifiers: (value: string[]) => void;
    setMaxConsumedBoosts: (value: number) => void;
    clearStore: () => void;
    setDisabledRcuIds: (value: string[]) => void;
    activeSelectedRcuIds(): string[];
    setWarningMessage: (value: string) => void;
};

const useQuickRepartitionStore = create<QuickRepartitionStore>((set, get) => ({
    quickRepartition: { selectedRcuIds: [], boostTotalAmount: undefined, boostPerMember: undefined, allRcuIds: [], maxConsumedBoosts: undefined, disabledRcuIds: [], warningMessage: undefined},
    setQuickRepartition: (quickRepartition) => set({ quickRepartition }),
    setSelectedRcuIdentifiers: (value) => set(state => ({ quickRepartition: { ...state.quickRepartition, selectedRcuIds: value }})),
    setBoostPerMember: (value) => set(state => ({ quickRepartition: { ...state.quickRepartition, boostPerMember: value }})),
    setBoostTotalAmount: (value) => set(state => ({ quickRepartition: { ...state.quickRepartition, boostTotalAmount: value }})),
    setAllRcuIdentifiers: (value) => set(state => ({ quickRepartition: { ...state.quickRepartition, allRcuIds: value }})),
    setMaxConsumedBoosts: (value) => set(state => ({ quickRepartition: { ...state.quickRepartition, maxConsumedBoosts: value }})),
    clearStore: () => set({ quickRepartition: { selectedRcuIds: [], boostTotalAmount: undefined, boostPerMember: undefined, allRcuIds: [], maxConsumedBoosts: undefined, disabledRcuIds: [], warningMessage: undefined}}),
    setDisabledRcuIds: (value) => set(state => ({ quickRepartition: { ...state.quickRepartition, disabledRcuIds: value }})),
    activeSelectedRcuIds: () => get().quickRepartition.selectedRcuIds.filter(e => !get().quickRepartition.disabledRcuIds.includes(e)),
    setWarningMessage: (value) => set(state => ({ quickRepartition: { ...state.quickRepartition, warningMessage: value }})),
}));



export default useQuickRepartitionStore;